"use strict";
// Task-param types and helpers for proportional base/bonus credits
// (flat offset + rate × numeric input or output field).
Object.defineProperty(exports, "__esModule", { value: true });
exports.proportionalValueSources = void 0;
exports.computeProportionalVariableCredits = computeProportionalVariableCredits;
exports.resolveCredits = resolveCredits;
exports.validatePaymentParams = validatePaymentParams;
exports.proportionalValueSources = {
    INPUT: 'Microtask Input',
    OUTPUT: 'Assignment Output',
};
function computeProportionalVariableCredits(rate, data) {
    const value = data === null || data === void 0 ? void 0 : data[rate.key];
    if (typeof value !== 'number' || value <= 0)
        return 0;
    return Math.floor(value * rate.creditsPerUnit);
}
function resolveCredits(enabled, flatOffset, rate, source, data) {
    if (!enabled ||
        !rate ||
        rate.source !== source ||
        !rate.key ||
        !Number.isFinite(rate.creditsPerUnit) ||
        rate.creditsPerUnit <= 0) {
        return flatOffset;
    }
    const total = flatOffset + computeProportionalVariableCredits(rate, data);
    if (rate.maxCredits && rate.maxCredits > 0) {
        return Math.min(total, rate.maxCredits);
    }
    return total;
}
function isNonNegativeFiniteNumber(value) {
    return typeof value === 'number' && Number.isFinite(value) && value >= 0;
}
function validateProportionalSide(label, enabled, flatOffset, rate) {
    if (!enabled)
        return null;
    const title = label === 'base' ? 'Base' : 'Bonus';
    if (typeof (rate === null || rate === void 0 ? void 0 : rate.source) !== 'string' || !(rate.source in exports.proportionalValueSources)) {
        return `${title} value source is required when proportional ${label} payments are enabled`;
    }
    if (typeof rate.key !== 'string' || rate.key.trim() === '') {
        return `${title} numeric key is required when proportional ${label} payments are enabled`;
    }
    if (!isNonNegativeFiniteNumber(rate.creditsPerUnit)) {
        return `${title} credits per unit must be a non-negative number`;
    }
    if (rate.maxCredits != null && !isNonNegativeFiniteNumber(rate.maxCredits)) {
        return `Max ${label} credits must be a non-negative number`;
    }
    if (rate.maxCredits != null && rate.maxCredits < flatOffset) {
        return `Max ${label} credits cannot be less than ${label} credits per microtask`;
    }
    return null;
}
/** Reject payment params that cannot be used to compute credits. */
function validatePaymentParams(params) {
    var _a;
    if (!isNonNegativeFiniteNumber(params.baseCreditsPerMicrotask)) {
        return 'Base credits per microtask must be a non-negative number';
    }
    if (!isNonNegativeFiniteNumber(params.bonusCreditsPerMicrotask)) {
        return 'Bonus credits per microtask must be a non-negative number';
    }
    return ((_a = validateProportionalSide('base', params.enableProportionalBasePayments, params.baseCreditsPerMicrotask, params.proportionalBase)) !== null && _a !== void 0 ? _a : validateProportionalSide('bonus', params.enableProportionalBonusPayments, params.bonusCreditsPerMicrotask, params.proportionalBonus));
}
//# sourceMappingURL=ProportionalPayments.js.map